import { render } from "./WelcomeScreen.vue?vue&type=template&id=a0f6eb34&scoped=true"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js"

import "./WelcomeScreen.vue?vue&type=style&index=0&id=a0f6eb34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f6eb34"]])

export default __exports__